// extracted by mini-css-extract-plugin
module.exports = {"Root":"DefaultSection_Root__2tUKG"};